import { Box, Button, Grid, Typography } from "@mui/material";
import * as React from "react";
import {
  CheckboxGroupInput,
  Edit,
  PasswordInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  useRecordContext,
} from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parsePhone from "../unit/inputFormat/parsePhone";
import OneZeroInput from "../unit/OneZeroInput";
import useNotify from "../unit/useNotify";
import Permissions from "./Permission";

//banker admin update it direct, no need use email button for bb2-24 2026-03
// const ResetPasswordEmailButton = () => {
//   const record = useRecordContext();
//   const email = record?.email;
//   const { successNotify, errorNotify } = useNotify();
//   const handleSendResetPasswordEmail = async () => {
//     if (!email) {
//       errorNotify("Email is required to reset password");
//       return;
//     }

//     const reqUrl = `send-reset-password-email`;
//     const response = await sendRequest(reqUrl, {
//       id: record?.id,
//       data: {
//         email: email,
//       },
//     });
//     if (response && (response.status == "200" || response.code == "200")) {
//       successNotify("Reset password email sent successfully!");
//     } else {
//       errorNotify("Failed to send reset password email. Please try again.");
//     }
//   };

//   return (
//     <>
//       <HmTextInput source="email" label="Email" required={true} readOnly />
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={handleSendResetPasswordEmail}
//         sx={{ mt: 2 }}
//       >
//         Send Reset Password Email
//       </Button>
//     </>
//   );
// };
const ChangeBankerPassword = ({ ...props }) => {
  const passwordRuleText =
    "Minimum 8 characters with at least 1 letter, 1 number, and 1 special character";
  const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/;
  const [passwordValue, setPasswordValue] = React.useState("");
  const [passwordInteracted, setPasswordInteracted] = React.useState(false);

  const passwordRules = {
    minLength: passwordValue.length >= 8,
    hasLetter: /[A-Za-z]/.test(passwordValue),
    hasNumber: /\d/.test(passwordValue),
    hasSpecial: /[^A-Za-z0-9\s]/.test(passwordValue),
  };

  const isPasswordValid = passwordPattern.test(passwordValue);

  const getPasswordRuleColor = (ruleValid: boolean) => {
    if (!passwordInteracted) {
      return "text.secondary";
    }

    return ruleValid ? "success.main" : "error.main";
  };

  const validateNewPassword = (value: string) => {
    if (!value) {
      return "Password is required";
    }

    if (!passwordPattern.test(value)) {
      return passwordRuleText;
    }

    return undefined;
  };

  return (
    <>
      <PasswordInput
        source="newPassword"
        label="Password"
        variant="outlined"
        fullWidth
        helperText={false}
        validate={validateNewPassword}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setPasswordValue(event.target.value);
          if (!passwordInteracted) {
            setPasswordInteracted(true);
          }
        }}
        onBlur={() => {
          setPasswordInteracted(true);
        }}
        sx={{
          "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor:
              passwordInteracted && !isPasswordValid
                ? "error.main"
                : "success.main",
          },
          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor:
              passwordInteracted && !isPasswordValid
                ? "error.main"
                : "success.main",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor:
                passwordInteracted && !isPasswordValid
                  ? "error.main"
                  : "success.main",
            },
          "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
            {
              borderColor:
                passwordInteracted && !isPasswordValid
                  ? "error.main"
                  : "success.main",
            },
        }}
      />
      <Typography
        variant="body2"
        sx={{
          mt: 1,
          pl: 0.5,
          whiteSpace: "nowrap",
          overflowX: "auto",
        }}
      >
        <Box
          component="span"
          sx={{
            color: getPasswordRuleColor(passwordRules.minLength),
          }}
        >
          Minimum 8 characters
        </Box>
        <Box component="span" sx={{ color: "text.secondary", mx: 0.75 }}>
          ,
        </Box>
        <Box
          component="span"
          sx={{
            color: getPasswordRuleColor(passwordRules.hasLetter),
          }}
        >
          1 letter
        </Box>
        <Box component="span" sx={{ color: "text.secondary", mx: 0.75 }}>
          ,
        </Box>
        <Box
          component="span"
          sx={{
            color: getPasswordRuleColor(passwordRules.hasNumber),
          }}
        >
          1 number
        </Box>
        <Box component="span" sx={{ color: "text.secondary", mx: 0.75 }}>
          ,
        </Box>
        <Box
          component="span"
          sx={{
            color: getPasswordRuleColor(passwordRules.hasSpecial),
          }}
        >
          1 special character
        </Box>
      </Typography>
    </>
  );
};
const BankerEdit = ({ ...props }) => {
  const record = useRecordContext(props);
  // console.log("BankerEdit record===============>>>>>:", record);
  const id = props.id;
  const curTab = props?.curTab;
  const [activeTab, setActiveTab] = React.useState(0);
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };
  const defaultBank = localStorage.getItem("bank");
  const auth = localStorage.getItem("authrole");

  return (
    <Edit
      {...props}
      basePath="/bankers"
      resource="bankers"
      sx={{
        borderRadius: "0px",
        marginTop: "0px",
        ".MuiPaper-root": { border: "none", borderRadiue: "none" },
        width: "100%",
        maxWidth: "100%",
        "& .MuiCard-root": {
          borderRadius: "0px",
          marginTop: "0px",
        },
        "& .RaEdit-noActions": {
          marginTop: "0px",
        },
        "& .MuiCardContent-root": {
          paddingBottom: "0px",
        },
      }}
      className="banker_edit_dialog_form"
    >
      <SimpleForm toolbar={false}>
        {curTab != "changePwd" && (
          <Box
            sx={{
              width: "100%",
              borderBottom: 1,
              borderColor: "divider",
              marginTop: "0px",
              ".MuiCardContent": { paddingTop: 0 },
            }}
          >
            {curTab && curTab == "info" && (
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Base Info
              </Typography>
            )}
            {/* {curTab && curTab == "changePwd" && (
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Change Password
            </Typography>
          )} */}

            {curTab && curTab == "permission" && (
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Permissions
              </Typography>
            )}
            {curTab && curTab == "useralert" && (
              <Typography variant="body2" color="textSecondary">
                Please select the events to receive email alerts.
              </Typography>
            )}
          </Box>
        )}
        <>
          {curTab && curTab == "info" && (
            <Box
              sx={{
                pt: 2,
                pb: 2,
              }}
            >
              {/* {auth == "admin" && (
                <ReferenceInput source="bank" reference="banks" readOnly>
                  <SelectInput
                    optionValue="sBank"
                    optionText="sBankName"
                    label="Bank"
                    defaultValue={defaultBank}
                    variant="outlined"
                    helperText={false}
                  />
                </ReferenceInput>
              )} */}
              <HmTextInput source="sFname" label="First Name" required={true} />
              <HmTextInput source="sLname" label="Last Name" required={true} />
              <HmTextInput source="email" label="Email" required={true} />

              <HmTextInput
                source="sMobilePhone"
                name="mobilephone"
                label="Mobile"
                format={formatPhone}
                parse={parsePhone}
              />
              {auth == "admin" && (
                <OneZeroInput
                  source="bankadmin"
                  name="bankadmin"
                  label="Admin"
                  helperText={false}
                  sx={{ mt: 0 }}
                />
              )}
            </Box>
          )}
          {curTab && curTab == "changePwd" && (
            <Box
              sx={{
                pt: 2,
                pb: 2,
              }}
              className="changePwd"
            >
              {/* <ResetPasswordEmailButton /> */}
              <ChangeBankerPassword id={id} />
            </Box>
          )}

          {curTab && curTab == "permission" && (
            <Box
              sx={{
                pt: 2,
                pb: 2,
              }}
              className="permission"
            >
              <Permissions record={record} id={id} />
            </Box>
          )}
          {curTab && curTab == "useralert" && (
            <Box
              sx={{
                pt: 2,
                pb: 0,
                width: "100%",
              }}
              className="useralert"
            >
              <UserAlertSetting record={record} id={id} />
            </Box>
          )}
        </>
      </SimpleForm>
    </Edit>
  );
};

const UserAlertSetting = ({ ...props }) => {
  const record = useRecordContext(props);
  const userAlertList = record?.userAlertData || {};
  // console.log("UserAlertSetting record===============>>>>>:", userAlertList);

  const creditChoices = [
    {
      id: "sReceiveAppSubmitMail",
      // name: "1. When a new application has been submitted",
      name: "New Application Submitted",
    },
    {
      id: "sReceiveAppValidatedMail",
      // name: "8. When application or applicant is verified by a 3rd party",
      name: "Application Verified by Referring Partner",
    },
    {
      id: "sReceiveAppFinalReviewMail",
      // name: "2. When an application is ready for Final Review",
      name: "Application Ready for Final Review",
    },
    {
      id: "sReceiveAppNotificationMail",
      // name: "3. When review has completed and the application is ready for Notification",
      name: "Application Ready for Notification",
    },
    {
      id: "sReceiveAppAcceptedCounteredMail",
      // name: "4. When applicant has accepted a countered application",
      name: "Counter Offer Accepted",
    },
    {
      id: "sReceiveAppAcceptedPreApprovalMail",
      // this is new setting on bb2,
      name: "Pre-Approval Offer Accepted",
    },
    {
      id: "sReceiveAppCompletedSignMail",
      // name: "5. When applicant has completed signing of loan documents",
      name: "Closing Documents Signed",
    },
    {
      id: "sReceiveAppBecomeActiveLoanMail",
      // name: "6. When application has become an Active Loan",
      name: "Application Becomes Active Loan",
    },
    {
      id: "sReceiveAppTemplatesChangedMail",
      // name: "7. When application and loan templates have changed",
      name: "Document Templates Changed",
    },
  ];

  // const accountChoices = [
  //   {
  //     id: "sReceiveAccountSubmitMail",
  //     name: "1. When a new application has been submitted",
  //   },
  //   //
  //   {
  //     id: "sReceiveAccountNotificationMail",
  //     name: "2. When review has completed and the application is ready for Notification",
  //   },
  //   {
  //     id: "sReceiveAccountCompletedSignMail",
  //     name: "3. When applicant has completed signing of account documents",
  //   },
  //   {
  //     id: "sReceiveAccountTemplatesChangedMail",
  //     name: "4. When application and other templates have changed",
  //   },
  // ];

  const loanChoices = [
    {
      id: "sReceive_event_pmt_loan_mod_requested",
      name: "Borrower Loan Modification Request",
    },
    {
      id: "sReceive_event_application_external_signing_completed",
      name: "Loan Modification E-Signature Completed",
    },
    //remove it on BB2-24, comment 2026-03-30.I think we can remove “ACH Switch Requested =>event_application_switch_ach" because it is sending email to the BC user only
    // {
    //   id: "sReceive_event_application_switch_ach",
    //   name: "ACH Switch Requested",
    // },
    {
      id: "sReceive_event_pmt_customer_transfer_failed",
      name: "ACH Payment Failed",
    },
    {
      id: "sReceive_event_pmt_attention_failed_transfer",
      name: "ACH Processing Put On Hold",
    },
    {
      id: "sReceive_event_application_switch_ach_complete",
      name: "ACH Switch Completed",
    },
  ];

  const applicationEvents = Array.isArray(userAlertList?.application)
    ? userAlertList.application
    : [];
  const accountEvents = Array.isArray(userAlertList?.account)
    ? userAlertList.account
    : [];
  const allSelectedEvents = new Set<string>([
    ...applicationEvents,
    ...accountEvents,
  ]);
  // console.log("Record =====>>:", record);
  const isCurrentUserInAlert = (category: string, field: string) => {
    const categoryEvents = userAlertList?.[category] || [];

    let check = categoryEvents.includes(field);
    console.log(`Alert check for ${category} - ${field}:`, check);
    return check;
  };

  const creditDefault = creditChoices
    .filter((item) => isCurrentUserInAlert("application", item.id))
    .map((item) => item.id);
  // const accountDefault = accountChoices
  //   .filter((item) => isCurrentUserInAlert("account", item.id))
  //   .map((item) => item.id);
  const loanDefault = loanChoices
    .filter((item) => isCurrentUserInAlert("application", item.id))
    .map((item) => item.id);

  return (
    <Grid container spacing={2} sx={{ width: "100%" }}>
      <Grid item xs={6} sm={6} md={6}>
        <Typography variant="h2">Credit Application</Typography>
        <CheckboxGroupInput
          source="userAlertCredit"
          label=""
          defaultValue={creditDefault}
          readOnly={false}
          row={false}
          fullWidth
          choices={creditChoices}
          variant="outlined"
        />
      </Grid>
      {/* <Grid item xs={4} sm={4} md={4}>
        <Typography variant="h2">Account Open</Typography>
        <CheckboxGroupInput
          source="userAlertAccount"
          label=""
          defaultValue={accountDefault}
          readOnly={false}
          row={false}
          fullWidth
          choices={accountChoices}
          variant="outlined"
        />
      </Grid> */}
      <Grid item xs={6} sm={6} md={6}>
        <Typography variant="h2">Loan Payment</Typography>
        <CheckboxGroupInput
          source="userAlertLoan"
          label=""
          defaultValue={loanDefault}
          readOnly={false}
          row={false}
          fullWidth
          choices={loanChoices}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
};

export default BankerEdit;
